<template>
    <i18n v-if="own.total === 0" path="own-and-foreign-allocation-count-without-own">
        <template #allAllocationCount>
            <span class="font-semibold">
                {{ allInRange }}
            </span>
        </template>
    </i18n>

    <i18n
        v-else-if="own.inRange === own.total"
        path="own-and-foreign-allocation-count"
        :args="{ ownCount: own.inRange, allCount: allInRange }"
    >
        <template #ownAllocationCount>
            <span class="font-semibold">
                {{ own.inRange }}
            </span>
        </template>

        <template #allAllocationCount>
            <span class="font-semibold">
                {{ allInRange }}
            </span>
        </template>
    </i18n>

    <i18n v-else path="own-and-foreign-allocation-count-with-own-outside-range" :args="{ ownTotalCount: own.total }">
        <template #ownInRangeAllocationCount>
            <span class="font-semibold">
                {{ own.inRange }}
            </span>
        </template>

        <template #ownTotalAllocationCount>
            <span class="font-semibold">
                {{ own.total }}
            </span>
        </template>

        <template #allAllocationCount>
            <span class="font-semibold">
                {{ allInRange }}
            </span>
        </template>
    </i18n>
</template>

<script setup lang="ts">
import type { OwnAndForeignAllocationCount } from '@/components/Timeline/logic/allocationCounts';
import { computed } from 'vue';

type OwnAndForeignAllocationCountTooltipTextProps = {
    allocationCount: OwnAndForeignAllocationCount;
};

const props = defineProps<OwnAndForeignAllocationCountTooltipTextProps>();

const own = computed(() => props.allocationCount.own);
const allInRange = computed(() => props.allocationCount.own.inRange + props.allocationCount.foreign.inRange);
</script>
